import { createContext, useContext } from "react";

export const GeoContext = createContext({
    geoAccepted: false
});

export function useGeolocalization() {
    return useContext(GeoContext);
}